import { ApolloClient, InMemoryCache } from "@apollo/client";
import "cross-fetch/polyfill";

const apolloClient = new ApolloClient({
  uri: `/api/graphqlRoute`,
  cache: new InMemoryCache(),
});

export default apolloClient;
